import { render, staticRenderFns } from "./D-3-2__QuiktipsCreateEdit_Description.vue?vue&type=template&id=456aa98c&"
import script from "./D-3-2__QuiktipsCreateEdit_Description.vue?vue&type=script&lang=js&"
export * from "./D-3-2__QuiktipsCreateEdit_Description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
